import { httpsCallable, HttpsCallable } from 'firebase/functions';

import {
  CreateRiskAssessmentRequest,
  EvaluationResult,
  FirebaseFunctionEnum,
  GetIpResponse,
  GetPartnerByTokenRequest,
  GetPersonaRequest,
  GetPersonaResponse,
  GetRequiredProgramsRequest,
  Partner,
  Program,
  ShortFormLeadResponse,
} from '@types';
import { firebaseFunctions } from 'src/firebase.config';

const BACKGROUND_CALLABLE_TIMEOUT_MS = 15_000;

export class CloudFunctionsService {
  constructor() {}

  public invokeSweeper: HttpsCallable<unknown, unknown> = httpsCallable(
    firebaseFunctions,
    FirebaseFunctionEnum.INVOKE_SWEEPER
  );

  public submitShortFormLead: HttpsCallable<unknown, ShortFormLeadResponse> =
    httpsCallable(
      firebaseFunctions,
      FirebaseFunctionEnum.SUBMIT_SHORT_FORM_LEAD
    );

  public getUserIp: HttpsCallable<unknown, GetIpResponse> = httpsCallable(
    firebaseFunctions,
    FirebaseFunctionEnum.GET_IP,
    { timeout: BACKGROUND_CALLABLE_TIMEOUT_MS }
  );

  public getPartnerByToken: HttpsCallable<GetPartnerByTokenRequest, Partner> =
    httpsCallable(firebaseFunctions, FirebaseFunctionEnum.GET_PARTNER_BY_TOKEN);

  public getPrograms: HttpsCallable<GetRequiredProgramsRequest, Program[]> =
    httpsCallable(firebaseFunctions, FirebaseFunctionEnum.GET_PROGRAMS);

  public blacklistEvent: HttpsCallable<unknown, unknown> = httpsCallable(
    firebaseFunctions,
    FirebaseFunctionEnum.BLACKLIST_EVENT
  );

  public createRiskAssessment: HttpsCallable<
    CreateRiskAssessmentRequest,
    unknown
  > = httpsCallable(
    firebaseFunctions,
    FirebaseFunctionEnum.CREATE_RISK_ASSESSMENT,
    { timeout: BACKGROUND_CALLABLE_TIMEOUT_MS }
  );

  public postEncrypt: HttpsCallable<unknown, { [key: string]: string }> =
    httpsCallable(firebaseFunctions, FirebaseFunctionEnum.POST_ENCRYPT);

  public postDecrypt: HttpsCallable<unknown, { [key: string]: string }> =
    httpsCallable(firebaseFunctions, FirebaseFunctionEnum.POST_DECRYPT);

  public sendEvaluation: HttpsCallable<
    { userId: string; language?: string },
    EvaluationResult[]
  > = httpsCallable(firebaseFunctions, FirebaseFunctionEnum.SEND_EVALUATION);
  public getPersona: HttpsCallable<GetPersonaRequest, GetPersonaResponse> =
    httpsCallable(firebaseFunctions, FirebaseFunctionEnum.GET_PERSONA);

  public resolveLeadDistribution: HttpsCallable<
    void,
    { servicer_id: string; distribution_method: string | null }
  > = httpsCallable(
    firebaseFunctions,
    FirebaseFunctionEnum.RESOLVE_LEAD_DISTRIBUTION
  );
}
